import { parse } from 'querystring';
import { setContext } from '@apollo/client/link/context';
import { getIn } from 'seamless-immutable';
import { removeUndef } from '@catalogo/core-helpers/utils';
import { readCookies } from '@catalogo/core-connect/cookies';
import { getPageType } from '@catalogo/core-connect/page-type';
import {
  getQs,
  getPath,
  appendTestABHeaders,
  appendOneDayDeliveryFiltered,
  appendXTid,
  appendAkamaiBot,
  appendSegments,
  appendB2BHeaders,
  appendSalesSolutionHeader,
} from './helpers';

export default (device, req, cache, config) => {
  const qs = getQs(req);
  const pathname = getPath(req);
  const parsedQs = parse(qs);

  // eslint-disable-next-line max-statements
  return setContext(({ variables }) => {
    const isProductPageQuery = getIn(variables, ['path'], '').indexOf('/produto/') !== -1;
    const pageType = getPageType(pathname);
    const { cookies } = readCookies(cache);
    const skipCache = parsedQs?.log == 'true' ? true : undefined;

    const {
      b2wOpn: opn,
      b2wRegion: region,
      mesoRegion,
      legionRegion,
      macroRegion,
      c_prime: prime,
      c_finance: finance,
      'B2W-UID': userid,
      'B2W-SID': sessionid,
      oneDayDelivery,
      b2wEPar: epar,
    } = cookies;

    const customerId = cookies[config?.cookiesKey?.customerId];
    const customerToken = cookies[config?.cookiesKey?.customerToken];

    let headers = {
      'x-skip-cache': skipCache,
      opn: parsedQs.opn || opn,
      region,
      mesoregion: mesoRegion,
      legionregion: legionRegion,
      macroregion: macroRegion,
      prime,
      finance,
      device,
      userid,
      sessionid,
      epar: parsedQs.epar || epar,
      page: isProductPageQuery ? pageType : undefined,
      pageType: pageType,
      'customer-token': customerToken,
      'customer-id': customerId,
      'one-day-delivery': oneDayDelivery,
      sitepage: parsedQs.sitepage,
    };

    headers = appendTestABHeaders(headers, cache, req);
    headers = appendOneDayDeliveryFiltered(headers, cache);
    headers = appendXTid(headers, cache);
    headers = appendSegments(headers, cache, cookies);
    headers = appendAkamaiBot(headers, cache);
    headers = appendB2BHeaders(headers, config, cookies);
    headers = appendSalesSolutionHeader(headers, cookies);

    return {
      headers: removeUndef(headers),
    };
  });
};
